export default "__VITE_ASSET__DNpuh406__"